import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17e2f02e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "sgrid" }
const _hoisted_3 = { class: "row justify-content-left" }
const _hoisted_4 = { class: "col card justify-content-left" }
const _hoisted_5 = { class: "d-flex flex-column justify-content-left" }
const _hoisted_6 = { class: "px-4 mx-auto my-2 justify-content-left" }
const _hoisted_7 = { class: "justify-content-left list-lines" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Apps", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = { href: "https://topomaps.co" }
const _hoisted_11 = ["src"]
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Topo Maps+ ")
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = { href: "https://topofire.com" }
const _hoisted_15 = ["src"]
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Topo Fire ")
const _hoisted_17 = {
  key: 0,
  class: "col card"
}
const _hoisted_18 = { class: "d-flex flex-column" }
const _hoisted_19 = { class: "px-4 mx-auto my-2" }
const _hoisted_20 = { class: "justify-content-right list-lines" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Topo Fire", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/settings#account" }, "Account", -1))
const _hoisted_24 = /*#__PURE__*/_createTextVNode()
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_26 = /*#__PURE__*/_createTextVNode("Support")
const _hoisted_27 = {
  key: 1,
  class: "col card"
}
const _hoisted_28 = { class: "d-flex flex-column" }
const _hoisted_29 = { class: "px-4 mx-auto my-2" }
const _hoisted_30 = { class: "justify-content-right" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Topo Maps+", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/plans" }, "Pro", -1))
const _hoisted_34 = /*#__PURE__*/_createTextVNode()
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/teams" }, "Teams", -1))
const _hoisted_37 = /*#__PURE__*/_createTextVNode()
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/settings#account" }, "Account", -1))
const _hoisted_40 = /*#__PURE__*/_createTextVNode()
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_42 = /*#__PURE__*/_createTextVNode("Support")
const _hoisted_43 = { class: "mx-auto text-center" }
const _hoisted_44 = {
  key: 0,
  class: "p-1"
}
const _hoisted_45 = /*#__PURE__*/_createTextVNode("NWCG Incident Response Pocket Guide (IRPG)")
const _hoisted_46 = { class: "p-1 copyright" }
const _hoisted_47 = /*#__PURE__*/_createTextVNode(" © 2023 Glacier Peak Studios LLC   |   All Rights Reserved   |   ")
const _hoisted_48 = /*#__PURE__*/_createTextVNode("Terms of Use")
const _hoisted_49 = /*#__PURE__*/_createTextVNode("   |   ")
const _hoisted_50 = /*#__PURE__*/_createTextVNode("Privacy")

import DownloadBtns from "@/components/DownloadBtns.vue";
import { computed } from "vue";
import { parseService } from "@/services/parse.service";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const isTopoFire = computed(() => {
  return parseService.isTopoFireApp();
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("p", _hoisted_7, [
                _hoisted_8,
                _hoisted_9,
                _createElementVNode("a", _hoisted_10, [
                  _createElementVNode("img", {
                    class: "logo-image",
                    src: require('@/assets/images/img/Icon-60-Rounded@3x.png'),
                    alt: "Logo Image"
                  }, null, 8, _hoisted_11),
                  _hoisted_12
                ]),
                _hoisted_13,
                _createElementVNode("a", _hoisted_14, [
                  _createElementVNode("img", {
                    class: "logo-image",
                    src: require('@/assets/images/img/TopoFire-60-Rounded@3x.png'),
                    alt: "Logo Image"
                  }, null, 8, _hoisted_15),
                  _hoisted_16
                ])
              ])
            ])
          ])
        ]),
        (_unref(isTopoFire))
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("p", _hoisted_20, [
                    _hoisted_21,
                    _hoisted_22,
                    _hoisted_23,
                    _hoisted_24,
                    _hoisted_25,
                    _createVNode(_component_router_link, { to: "/help" }, {
                      default: _withCtx(() => [
                        _hoisted_26
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("p", _hoisted_30, [
                    _hoisted_31,
                    _hoisted_32,
                    _hoisted_33,
                    _hoisted_34,
                    _hoisted_35,
                    _hoisted_36,
                    _hoisted_37,
                    _hoisted_38,
                    _hoisted_39,
                    _hoisted_40,
                    _hoisted_41,
                    _createVNode(_component_router_link, { to: "/help" }, {
                      default: _withCtx(() => [
                        _hoisted_42
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ]))
      ])
    ]),
    _createElementVNode("div", _hoisted_43, [
      _createVNode(DownloadBtns, { centered: true }),
      (_unref(isTopoFire))
        ? (_openBlock(), _createElementBlock("p", _hoisted_44, [
            _createVNode(_component_router_link, {
              to: "/nwcg-incident-response-pocket-guide",
              class: "tos"
            }, {
              default: _withCtx(() => [
                _hoisted_45
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("p", _hoisted_46, [
        _hoisted_47,
        _createVNode(_component_router_link, {
          to: "/tos",
          class: "tos"
        }, {
          default: _withCtx(() => [
            _hoisted_48
          ]),
          _: 1
        }),
        _hoisted_49,
        _createVNode(_component_router_link, {
          to: "/privacy",
          class: "tos"
        }, {
          default: _withCtx(() => [
            _hoisted_50
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})